module.exports = __webpack_public_path__ + "static/media/key-logo.ffab1ca3.png";